import { Box, IconButton, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { ChecklistItem } from '../../../apis/serviceHistoryApi';
import { Check, Photo } from '@mui/icons-material';
import { green } from '@mui/material/colors';
import styled from '@emotion/styled';

interface ChecklistTableProps {
  entries: ChecklistItem[];
  showHeader?: boolean | null;
  fullWidth?: boolean | null;
  onPictureClicked?: (pictureId: string) => void;
}

const CheckIcon = styled(Check)`
  width: 20px;
  height: 20px;
  font-weight: 600;
  color: ${green[500]};
`;

const PhotoIcon = styled(Photo)`
  width: 22px;
  height: 22px;
`;

const ChecklistTable: React.FC<ChecklistTableProps> = ({ entries, showHeader, fullWidth, onPictureClicked }) => {
  return (
    <Box mt={4} ml={1} maxWidth={fullWidth ? 910 : 300}>
      {showHeader && (
        <Typography variant="subtitle2" ml={1} fontWeight={600}>
          Services Performed
        </Typography>
      )}
      <Table sx={{ marginTop: 2 }}>
        {entries.length === 0 && (
          <TableBody>
            <TableCell
              sx={{
                borderWidth: 1,
                borderColor: (theme) => theme.palette.divider,
                borderStyle: 'solid',
                padding: 2,
              }}
            >
              None
            </TableCell>
          </TableBody>
        )}
        {entries.length > 0 && (
          <TableBody>
            {entries.map((entry, index) => (
              <TableRow key={`reading_${index}`}>
                <TableCell
                  sx={{
                    width: '40px',
                    borderWidth: 1,
                    borderColor: (theme) => theme.palette.divider,
                    borderStyle: 'solid',
                    padding: 0,
                    paddingLeft: 2,
                    paddingTop: 1,
                  }}
                >
                  <CheckIcon />
                </TableCell>
                <TableCell
                  sx={{
                    borderWidth: 1,
                    borderColor: (theme) => theme.palette.divider,
                    borderStyle: 'solid',
                    borderRightWidth: 0,
                    paddingLeft: 2,
                    paddingTop: 2,
                    paddingBottom: 2,
                  }}
                >
                  {entry.description}
                </TableCell>
                <TableCell
                  sx={{
                    borderWidth: 1,
                    borderColor: (theme) => theme.palette.divider,
                    borderStyle: 'solid',
                    borderLeftWidth: 0,
                    paddingRight: 1,
                    paddingTop: 0,
                    paddingBottom: 0,
                    textAlign: 'right',
                  }}
                >
                  {entry.pictureId ? (
                    <IconButton
                      sx={{ padding: 1.5, color: (theme) => theme.palette.secondary.dark }}
                      aria-label="View photo"
                      title="View photo"
                      onClick={() => {
                        if (onPictureClicked && entry.pictureId) onPictureClicked(entry.pictureId);
                      }}
                    >
                      <PhotoIcon color="secondary"></PhotoIcon>
                    </IconButton>
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </Box>
  );
};

export default ChecklistTable;
